import React, { useEffect, useState } from 'react';
import { Menu } from "antd";
import { Link } from 'react-router-dom';
import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
// import ContextMenu from "./ContextMenu";

import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { useSelector } from "react-redux";
import { useHistory } from 'react-router-dom'
import { useAuth } from "../../authentication";
import * as globalFunction from 'util/GlobalFunction';

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);
  const { authUser } = useAuth();

  const [isShow, setIsShow] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [mouseEvent, setMouseEvent] = useState(null);

  const getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  const history = useHistory()

  const onClick = (MenuItem) => {
    setIsShow(false);
    // Public API 文档菜单项，通过隐藏表单 POST 打开，不走路由
    if (MenuItem.key === '/public-api-doc') {
      globalFunction.openPublicApiDoc();
      return;
    } else {
      history.push(MenuItem.key)
    }
  }

  function getItem(
    label: React.ReactNode,
    key?: React.Key | null,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  function onContextMenu(e, menuItem) {
    setIsShow(true);
    setMouseEvent(e);
    setSelectedMenuItem(menuItem);
    e.preventDefault();
    return false;
  }

  if ((history.location.pathname == '/admin/system-notification' ||
    history.location.pathname == '/admin/role-menu' ||
    history.location.pathname == '/admin/initialize-company' ||
    history.location.pathname == '/admin/company-list' ||
    history.location.pathname == '/admin/company-add-module') && authUser.Company.CompanyId != 15) {
    history.push('/dashboard');
  }

  let defaultOpenKeys = [];
  const items: MenuItem[] = [];

  authUser.CompanyMenuList.forEach(menu => {
    let child = null;

    if (menu.ChildCompanyMenuList !== null) {
      child = [];
      menu.ChildCompanyMenuList.forEach(childMenu => {
        if (childMenu.DefaultExpand) {
          defaultOpenKeys.push(childMenu.Url);
        }
        child.push(getItem(<Link title={childMenu.Key} to={{ pathname: childMenu.Url, key: childMenu.Key }}>{childMenu.Key}</Link>, childMenu.Url));
      });
    }

    if (menu.DefaultExpand) {
      defaultOpenKeys.push(menu.Url);
    }

    if (child !== null) {
      items.push(getItem(<span title={menu.Key}>{menu.Key}</span>, menu.Url, <i className={menu.Icon} />, child));
    } else if (menu.Url === '/public-api-doc') {
      // Public API 文档菜单不使用 Link，避免触发路由跳转，由 onClick 处理
      items.push(getItem(<span title={menu.Key}>{menu.Key}</span>, menu.Url, <i className={menu.Icon} />));
    } else {
      items.push(getItem(<Link title={menu.Key} to={{ pathname: menu.Url, key: menu.Key }}>{menu.Key}</Link>, menu.Url, <i className={menu.Icon} />, child));
    }
  });

  let check = false;
  authUser.CompanyMenuList.forEach(menu => {
    if (menu.ChildCompanyMenuList !== null) {
      menu.ChildCompanyMenuList.forEach(childMenu => {
        if (history.location.pathname + history.location.search === childMenu.Url) {
          document.title = childMenu.Key;
          check = true;
        }
      });
    }

    if (history.location.pathname === menu.Url) {
      document.title = menu.Key;
      check = true;
    }
  });

  console.log(history.location.pathname + history.location.search);
  //一些不在menu里的特殊url的判断
  let path = [];
  path.push('/jobs?');
  path.push('/documents?');
  path.push('/job/detail');
  path.push('/referral-job/detail');
  path.push('/assessment-checklist/detail');
  path.push('/job/log');
  path.push('/approval/detail');
  path.push('/sub-job/detail');
  path.push('/adjoining-property/detail');
  path.push('/admin/action-pack-detail');
  path.push('/admin/client-job-template?');
  path.push('/admin/client-job-template-detail');
  path.push('/admin/job-data-template?');
  path.push('/admin/job-data-template-detail');
  path.push('/admin/client-user');
  path.push('/admin/client');
  path.push('/admin/action-pack');
  path.push('/admin/ai-knowledge-store');
  path.push('/admin/authority-service-request-pricing');
  path.push('/admin/authority-property-info-lodgement');
  path.push('/admin/inspection-lodgement-settings');
  path.push('/service-request-list');
  path.push('/dashboard');
  path.push('/admin/app-integration-redirect');
  path.push('/subjob-scheduler');
  path.push('/my-profile');
  path.push('/online-session-tracking');
  path.push('/error');
  path.push('/help');
  path.push('/ai');
  path.push('/ai-test');
  path.push('/business/jobDetail/ai');
  path.push('/subjob-scheduler-calendar');
  path.push('/timesheet-weekly');
  path.push('/public-api-doc');

  path.map(item => {
    if ((history.location.pathname + history.location.search).indexOf(item) === 0) {
      check = true;
    }
  })

  if (!check) {
    history.push('/dashboard');
  }

  return (
    <>
      <SidebarLogo sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
      <div className="gx-sidebar-content">
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={defaultOpenKeys}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline"
            items={items}
            onClick={onClick}
          >
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);
